<template>
    <div :id="id" :year="year"></div>
</template>

<script>
import EmCommonApi from "@/mixin/em/common/api";
import * as echarts from 'echarts';

export default {
    name: "chartDept",
    mixins: [EmCommonApi],
    props: {
        id: String,
        year: String,
    },
    data() {
        return {
            chart: {},
            dataValueX: [],
            dataValueY: [],
            option: {},
            fresh: {},
        }
    },
    watch: {
        //监听year的变化，这个year是父组件传递的参数，利用watch监听再刷新当前子组件
        year(newValue, oldValue) {
            console.log("旧年份：" + oldValue + "父组件传递的新年份：" + newValue)
            this.getRemoteData();
        }
    },
    created() {
        //子组件自己初始化年份
        if (this.year === "") {
            this.year = new Date().getFullYear();
        }
    },
    mounted() {
        //window.addEventListener('resize', this.chart.resize, false);
        //这里可以屏蔽了，用watch生命周期监控year就可以触发了
        //this.getRemoteData();

        //定时轮巡查询
        //this.fresh = setInterval(() => {
        //   this.getRemoteData();
        //   window.addEventListener('resize', this.chart.resize, false)
        // },  10000);

    },
    beforeDestroy() {
        clearInterval(this.fresh);
        //window.removeEventListener('resize', this.chart.resize, false)
    },
    methods: {
        getRemoteData() {
            let _this = this;
            const _api = `${this.$_emApiMixin_moduleBaseApi("emAcctHandleRecordAhr")}/emAcctHandleRecordAhr/echart/chartDept`
            console.log(_api)

            //注意给后端传递年份查询参数 {s_year: this.year}
            this.$_emApiMixin_post(_api, {s_year: _this.year}, false).then(value => {
                let data = value.data;
                //console.log('--------------- 按部门统计 后端返回结果 ----------------')
                //console.log(data)

                let deptData = []
                let numData = []

                for (let key in data) {
                    deptData.push(data[key].name);
                    numData.push(data[key].value);
                }


                // console.log(deptData)
                // console.log(numData)

                this.dataValueX = deptData;
                this.dataValueY = numData;

                //记得异步调用后端，要写进then里渲染
                //渲染echart
                this.loadChart()
            })


        },
        loadChart() {
            this.option = {
                title: {
                    text: this.year + '年度部门设备故障统计'
                },
                tooltip: {},
                legend: {
                    data: ['事故频次']
                },
                xAxis: {
                    data: this.dataValueX,
                    axisLabel: {
                        interval: 0, // 强制显示所有标签
                        // rotate: 45,  // 标签旋转角度
                        // formatter: function (value) { // 对标签进行格式化
                        //     return value.split("").join("\n"); // 每个字符换行显示
                        // }
                    }
                },
                yAxis: {},
                series: [{
                    name: '频次',
                    type: 'bar',
                    itemStyle: {
                        color: '#FF9900'
                    },
                    data: this.dataValueY,
                }]
            }
            this.chart = echarts.init(document.getElementById(this.id));
            this.chart.setOption(this.option)

            //echart浏览器自动缩放
            let myChart = this.chart;
            window.addEventListener('resize', () => {
                myChart.resize();
            })
        }
    }
}
</script>

<style scoped>

</style>
